import React, { useState } from 'react';
// import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import "./index.scss";

import ARecord from "../../DNSRecord/ARecord";
import AAARecord from "../../DNSRecord/AAARecord";
import CNameRecord from "../../DNSRecord/CNAMERecord";
import MXRecord from "../../DNSRecord/MXRecord";
import NSRecord from "../../DNSRecord/NSRecord";
import SOARecord from "../../DNSRecord/SOARecord";
import TXTRecord from "../../DNSRecord/TXTRecord";

import { plusIcon, minusIcon } from "../../../../../../../utils/icons";


const DNSRecordInformation = ({selectedSubdomain, domainId, scanId, organizationId, currentPageType}) => {

    const [seletedInfo, setSelectedInfo] = useState("");

    const changeSelectedInfo = (data) => {
        if(data === seletedInfo ) {
            setSelectedInfo("")
        } else {
            setSelectedInfo(data)
        }
    }

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
        >
            <div className="record-container-content mt-3 p-2">
                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{changeSelectedInfo('aRecords')}}>
                    <h2 className="heading">A Records</h2>
                    {seletedInfo === "aRecords" ? minusIcon() : plusIcon()}
                </div>
                {seletedInfo === "aRecords" && <div className="table-container record-table">
                    <ARecord domainId={domainId} scanId={scanId} organizationId={organizationId} selectedSubdomain={selectedSubdomain} currentPageType={currentPageType}/>
                </div>}
            </div>
            <div className="record-container-content mt-3 p-2">
                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{changeSelectedInfo('aaaRecords')}}>
                    <h2 className="heading">AAAA Records</h2>
                    {seletedInfo === "aaaRecords" ? minusIcon() : plusIcon()}
                </div>
                {seletedInfo === "aaaRecords" && <div className="table-container record-table">
                    <AAARecord domainId={domainId} scanId={scanId} organizationId={organizationId} selectedSubdomain={selectedSubdomain} currentPageType={currentPageType} />
                </div>}
            </div>
            <div className="record-container-content mt-3 p-2">
                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{changeSelectedInfo('cnameRecords')}}>
                    <h2 className="heading">CNAME Records</h2>
                    {seletedInfo === "cnameRecords" ? minusIcon() : plusIcon()}
                </div>
                {seletedInfo === "cnameRecords" && <div className="table-container record-table">
                    <CNameRecord domainId={domainId} scanId={scanId} organizationId={organizationId} selectedSubdomain={selectedSubdomain} currentPageType={currentPageType}/>
                </div>}
            </div>
            <div className="record-container-content mt-3 p-2">
                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{changeSelectedInfo('mxRecords')}}>
                    <h2 className="heading">MX Records</h2>
                    {seletedInfo === "mxRecords" ? minusIcon() : plusIcon()}
                </div>
                {seletedInfo === "mxRecords" && <div className="table-container record-table">
                    <MXRecord domainId={domainId} scanId={scanId} organizationId={organizationId} selectedSubdomain={selectedSubdomain} currentPageType={currentPageType} />
                </div>}
            </div>
            <div className="record-container-content mt-3 p-2">
                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{changeSelectedInfo('nsRecords')}}>
                    <h2 className="heading">NS Records</h2>
                    {seletedInfo === "nsRecords" ? minusIcon() : plusIcon()}
                </div>
                {seletedInfo === "nsRecords" && <div className="table-container record-table">
                    <NSRecord domainId={domainId} scanId={scanId} organizationId={organizationId} selectedSubdomain={selectedSubdomain} currentPageType={currentPageType}/>
                </div>}
            </div>
            <div className="record-container-content mt-3 p-2">
                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{changeSelectedInfo('soaRecords')}}>
                    <h2 className="heading">SOA Records</h2>
                    {seletedInfo === "soaRecords" ? minusIcon() : plusIcon()}
                </div>
                {seletedInfo === "soaRecords" && <div className="table-container record-table">
                    <SOARecord domainId={domainId} scanId={scanId} organizationId={organizationId} selectedSubdomain={selectedSubdomain} currentPageType={currentPageType}/>
                </div>}
            </div>
            <div className="record-container-content mt-3 p-2">
                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{changeSelectedInfo('txtRecords')}}>
                    <h2 className="heading">TXT Records</h2>
                    {seletedInfo === "txtRecords" ? minusIcon() : plusIcon()}
                </div>
                {seletedInfo === "txtRecords" && <div className="table-container record-table">
                    <TXTRecord domainId={domainId} scanId={scanId} organizationId={organizationId} selectedSubdomain={selectedSubdomain} currentPageType={currentPageType}/>
                </div>}
            </div>
        </motion.div>
    )
}

export default DNSRecordInformation;